
// import {storesIDsWithCustomRulesZeroPayment } from './storeIdsWithCustomRules';

export const customPriceRedirectionRules = (organization, booking) => {

    let customRedirect = null;

    // TODO: check if this can be done without hardcoding the rules and the ID

    // checking IDs
    // if (storesIDsWithCustomRulesZeroPayment.includes(organization.id)) {
    //     customRedirect = 'c/confirmacion/' + booking.id;
    // }

    // checking names
    if (organization.name.includes('pc*')) {
        customRedirect = 'c/confirmacion/' + booking.id;
    }

    return customRedirect;
}